import {LoggingConfigurationInterface, LogLevel} from './types';

/**
 * Default configuration {@link LoggingConfigurationInterface} to be used
 * as default one for {@link Log} instance.
 */
export const DEFAULT_LOGGING_CONFIGURATION: LoggingConfigurationInterface = {
  level: LogLevel.DEBUG,
  console: false,
  datadogTracer: undefined,
  datadogBrowser: false,
  samplingRateForLowPrioResources: 1,
};
